import { render, staticRenderFns } from "./ProjectWorkerCard.vue?vue&type=template&id=d96e63ca&"
import script from "./ProjectWorkerCard.vue?vue&type=script&lang=js&"
export * from "./ProjectWorkerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports